import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { UserCertificatesService } from './user-certificates.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from '@fuse/services/common.service';
import { fuseAnimations } from '@fuse/animations';

import { CommonImageViewerDialogComponent } from '@fuse/Dialog/common-image-viewer-dialog/common-image-viewer-dialog.component';
import { ConfirmationDialogComponent } from '@fuse/Dialog/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GenerateCertificateService } from '../generate-certificate/generate-certificate.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-user-certificate',
  templateUrl: './user-certificate.component.html',
  styleUrls: ['./user-certificate.component.scss'],
  animations: fuseAnimations
})
export class UserCertificateComponent implements OnInit {

  displayedColumns: string[] = ['name', 'email', 'phoneNumber', 'dateOfGeneration', 'eventName', 'action'];
  dataSource;
  maxAvailableRecordsInTable;
  filter = {
    eventId: 0,
    contactGroupId: 0,
    search: '',
    pageSize: 10,
    pageIndex: 1,
    filterType: 0,
    startTime: 0,
    endTime: 0
  }

  allContactGroupList: any[] = []



  selectedFilterType = new FormControl('all');
  isDownloading = false;

  constructor(
    private _ToolbarService: ToolbarService,
    private _fuseProgressBarService: FuseProgressBarService,
    public _UserCertificatesService: UserCertificatesService,
    public _commonService: CommonService,
    private _matDialog: MatDialog,
    private _snackbar: MatSnackBar,
    private _generateCertificateService: GenerateCertificateService,
    private cdr: ChangeDetectorRef,
  ) {

    this._UserCertificatesService.getAllEvents();
    this.setToolBarTitle(false);

    if (this._UserCertificatesService?.filterFor) {
      this.filter.eventId = this._UserCertificatesService.filterFor;
    }

  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this._UserCertificatesService.certificates);
    this.maxAvailableRecordsInTable = this._UserCertificatesService.totalRecords;


    this._generateCertificateService.getGroups({}).then((res: any) => {
      console.log("all contact groups", res);
      if (res.data.groupList.length) {
        this.allContactGroupList = res.data.groupList;
      } else {
        this.allContactGroupList = []
      }

    })
  }


  setToolBarTitle(edit) {
    if (edit) {
      // for title
      this._ToolbarService._ToolBarTitle.next("Select Attendees");
      // for btn
      this._ToolbarService._isBackBtnShow.next(true);
    } else {
      // for title
      this._ToolbarService._ToolBarTitle.next("Generated Certificate's");
      // for btn
      this._ToolbarService._isBackBtnShow.next(false);
    }
  }

  onSearch(val) {
    this.filter.pageIndex = 1
    this.filter.search = val
    this.filterData();
  }


  @ViewChild('search', { static: true }) search;
  clearSearch() {
    this.filter.search = ''
    this.search.nativeElement.focus()
    this.filterData()
  }


  onEventFilterSelect(val, type) {

    console.log("onEventFilterSelect value", val);

    if (type == 'group') {
      this.filter.contactGroupId = val.value;
      this.filter.eventId = 0;
      this.filter.filterType = 2;
    } else {
      this.filter.eventId = val.value;
      this.filter.contactGroupId = 0;
      this.filter.filterType = 1;
    }

    this.filterData()
  }

  clearFilter() {
    this.filter.eventId = 0;
    this.filter.search = '';
    this.filter.startTime = null;
    this.filter.endTime = null;
    this.filterData();
  }

  onPageChange(event) {
    this.filter.pageIndex = event.pageIndex + 1
    this.filter.pageSize = event.pageSize
    this.filterData()
  }

  filterData() {


    const payload = { ...this.filter };

    payload.startTime = payload.startTime ? new Date(payload.startTime).getTime() : 0;
    payload.endTime = payload.endTime ? new Date(payload.endTime).getTime() : 0;


    this._fuseProgressBarService.show()
    this._UserCertificatesService.getAllCertificateUserList(payload).then((result: any) => {

      console.log("this.filter result", result);
      this._fuseProgressBarService.hide()
      if (result.status == 200) {
        this.dataSource.data = result.data.certificates;
        this.maxAvailableRecordsInTable = result.data.totalRecords;

        this.cdr.detectChanges()
      } else if (result.status == 400) {
        this.dataSource.data = []
        this.maxAvailableRecordsInTable = 0;
      }
      else {
        this.dataSource.data = []
        this.maxAvailableRecordsInTable = 0
      }
    })
  }

  onViewCertificate(image) {
    const dialog = this._matDialog.open(CommonImageViewerDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '768px',
      autoFocus: false,
      data: {
        image: image,
        imageWidthSize: '100%',
        message: null,
        buttonText: 'Download',
        title: 'View Certificate'
      }
    })

  }


  downloadImage(imageUrl: string) {
    fetch(imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'downloaded-certificate.jpg';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error downloading image:', error));
  }


  onDelete(id) {
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      disableClose: false,
      data: {
        message: 'Are you sure you want to delete this Certificate Template?',
        image: '/assets/ui/delete.png',
        focus: 'right',
        deleteItem: 'Delete Certificate Template?',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }
    })
    dialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this._commonService.onDeleteGeneratedCertificate({ id: String(id) }).then((res: any) => {
          if (res.status == 200) {
            this._snackbar.open(res.message, 'OKAY', { duration: 2000 })
            this.filterData();
          } else {
            this._snackbar.open(res.message, 'OKAY', { duration: 2000 })
          }
        })
      }
    })
  }


  onFilterChange(val) {

    this.filter.eventId = 0;
    this.filter.contactGroupId = 0;

    if (val.value == 'by-event') {
      this.filter.filterType = 1;
    } else {
      this.filter.filterType = 2;
    }
    this.filterData()

  }


  downloadZip() {
    this.isDownloading = true; // Show spinner

    this._commonService.onZipDownload(this.filter).then((res: any) => {
      if (res.status === 200) {
        console.log("Downloading zip from:", res.data.zipLink);

        fetch(res.data.zipLink)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'downloaded-zip.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => console.error('Error downloading zip:', error))
          .finally(() => {
            this.isDownloading = false; // Hide spinner after completion
          });

      } else {
        this._snackbar.open(res.message, 'OKAY', { duration: 2000 });
        this.isDownloading = false; // Hide spinner on error
      }
    }).catch(() => this.isDownloading = false);
  }

  isEndTimeDisabled(): boolean {
    return this.filter.startTime === 0 || this.filter.startTime === null;
  }

  onDateChange() {
    // Validate dates
    if (this.filter.startTime && this.filter.endTime && this.filter.startTime !== 0 && this.filter.endTime !== 0) {
      if (this.filter.startTime > this.filter.endTime) {
        this._snackbar.open('Start time cannot be after end time', 'OKAY', { duration: 2000 });
        this.filter.startTime = 0;
        return;
      }
    }
    this.filterData();
  }

}
